import styled from "styled-components";

const StyledMain = styled.main`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .info{
        font-family: 'Lexend Deca';
        font-style: normal;
        font-weight: 400;
        font-size: 17.976px;
        color: #666666;
    }
    .container{
        width: 80%;
    }
`;

export { StyledMain }